// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { Spotlight } from './Spotlight';

export default Spotlight;
